import { render, staticRenderFns } from "./bdMap.vue?vue&type=template&id=317d36e0&scoped=true&"
import script from "./bdMap.vue?vue&type=script&lang=js&"
export * from "./bdMap.vue?vue&type=script&lang=js&"
import style0 from "./bdMap.vue?vue&type=style&index=0&id=317d36e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317d36e0",
  null
  
)

export default component.exports